import { FC, PropsWithChildren, useEffect } from "react";
import { fetchPrices, fetchConfig } from "@/common/store/config/slice";
import { useAppDispatch } from "@/common/store/redux";
const ProviderConfig: FC<PropsWithChildren> = props => {
  const {
    children
  } = props;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchConfig());
    dispatch(fetchPrices());
  }, [dispatch]);
  return <>{children}</>;
};
export default ProviderConfig;